const SCRIPT_MARKER = 'data-gtm-injected';

export function injectGtm(
  containerId: string | null | undefined
): void {
  if (typeof document === 'undefined') return;
  if (!containerId || !containerId.trim()) return;
  if (document.head.querySelector(`script[${SCRIPT_MARKER}="true"]`)) return;

  const id = containerId.trim();

  const script = document.createElement('script');
  script.setAttribute(SCRIPT_MARKER, 'true');
  script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${id}');`;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  noscript.setAttribute(SCRIPT_MARKER, 'true');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
}
